module.exports = __webpack_public_path__ + "img/user-12.745b63d6.jpg";